'use client'

import type * as React from 'react'

import {
	SidebarGroup,
	SidebarGroupContent,
	SidebarMenu,
	SidebarMenuButton,
	SidebarMenuItem,
} from '@/components/ui/sidebar'

import type { LucideIcon as Icon } from 'lucide-react' // Use LucideIcon aliased as Icon
import { Link } from 'react-router-dom'
import { useTranslation } from 'react-i18next'

export function NavSecondary({
	items,
	...props
}: {
	items: {
		key: string
		url: string
		icon: Icon
	}[]
} & React.ComponentPropsWithoutRef<typeof SidebarGroup>) {
	const { t } = useTranslation()
	return (
		<SidebarGroup {...props}>
			<SidebarGroupContent>
				<SidebarMenu>
					{items.map((item) => (
						<SidebarMenuItem key={item.key}>
							<SidebarMenuButton asChild>
								<Link to={item.url}>
									<item.icon />
									<span>{t(item.key)}</span>
								</Link>
							</SidebarMenuButton>
						</SidebarMenuItem>
					))}
				</SidebarMenu>
			</SidebarGroupContent>
		</SidebarGroup>
	)
}
